export const styles = {
  dialogContent: {
    width: '480px',
  },
  icon: {
    width: '20px',
    height: '20px',
  },
  textField: {
    mt: '20px',
    width: '100%',
  },
  footer: {
    mt: '37px',
    justifyContent: 'space-between',
  },
  switchTextContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  switchIcon: {
    width: '20px',
    height: '20px',
    ml: '6px',
    color: 'text.secondary',
  },
  switchActiveIcon: {
    width: '20px',
    height: '20px',
    ml: '6px',
    color: 'primary.main',
  },
};
